/**
 * Find a poster by its type from an array of poster objects
 * @param {Array} posters - Array of poster objects
 * @param {string} type - The exact type string to match (e.g., "Web Portrait", "Web Landscape", "Web Banner")
 * @returns {Object|undefined} - The complete poster object or undefined if not found
 */
export const getPosterByType = (posters, type) => {
  // Basic safety checks
  if (!posters || !Array.isArray(posters) || !type) {
    return undefined;
  }

  // Find poster with exact type match
  const posterItem = posters.find((poster) => poster?.type === type);
  
  return posterItem;
};

/**
 * Convenience function to get poster URL by type
 * @param {Array} posters - Array of poster objects
 * @param {string} type - The exact type string to match
 * @returns {string|undefined} - The poster URL or undefined if not found
 */
export const getPosterUrlByType = (posters, type) => {
  const poster = getPosterByType(posters, type);
  return poster?.url;
};

// Keep the old function for backward compatibility (deprecated)
// TODO: Remove this after migration is complete
export const findPoster = (posters, posterType) => {
  console.warn('findPoster is deprecated. Use getPosterByType instead.');
  
  let posterUrl;
  if (posterType === "banner") {
    const posterItem = posters?.find((poster) => poster?.banner);
    posterUrl = posterItem?.url;
    return posterUrl;
  } else if (posterType === "vertical") {
    const posterItem = posters?.find((poster) => poster?.vertical);
    posterUrl = posterItem?.url;
    return posterUrl;
  } else if (posterType === "horizontal") {
    const posterItem = posters?.find((poster) => poster?.vertical == false);
    posterUrl = posterItem?.url;
    return posterUrl;
  } else if (posterType === "horizontal-low") {
    const posterItem = posters?.find(
      (poster) => poster?.type == "HorizontalLow"
    );
    posterUrl = posterItem?.url;
    return posterUrl;
  }
};
